module.exports = __webpack_public_path__ + "static/media/star-track.028ccb6f.svg";